export const selectThreads = state => state.threads.threads;
export const selectThreadsSearchQuery = state => state.threads.searchQuery;
export const selectThreadsStatus = state => state.threads.fetchThreadsStatus;
export const selectCreateThreadStatus = state => state.threads.createThreadStatus;